module.exports = __webpack_public_path__ + "img/boxing.f8101a73.jpg";